import React, { Component } from 'react';
import * as requestLib from '../lib/requestLib';

export default class RightMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isCanvas: false,
        };

        this.baseUrl = requestLib.getUrl();
    }

    render() {
        // if (this.props.groupList && this.props.groupList.length == 0) {
        //     alert('Sorry. You must join a group.');
        //     return null;
        // }

        return (
            <React.Fragment>
                <div
                    className={
                        this.props.show === 'true' ? 'menu menuShow' : 'menu'
                    }
                >
                    <ul className="mainMenu">
                        <li>
                            <a href={this.baseUrl + 'search'}>Search</a>
                        </li>
                        <li>
                            <a
                                onClick={() =>
                                    this.setState({ isCanvas: true })
                                }
                                className={'pointer'}
                            >
                                Canvas
                            </a>
                        </li>
                        <li>
                            <a href={this.baseUrl + 'group'}>Group</a>
                        </li>
                        <li>
                            <a href={this.baseUrl + 'setting'}>Setting</a>
                        </li>
                        <li>
                            <a href={this.baseUrl + 'askus'}>Ask us</a>
                        </li>
                    </ul>
                    <ul className="subMenu">
                        <li>
                            <a href={this.baseUrl + 'about'}>About us</a>
                        </li>
                        <li>
                            <a href={this.baseUrl + 'subscribe'}>Subscribe</a>
                        </li>
                        {/*<li><a href="//pro.mimic.us/contactus">Contact us</a></li>*/}
                        <li>
                            <a href={this.baseUrl + 'Termsofuse'}>
                                Terms of Use
                            </a>
                        </li>
                        <li>
                            <a href={this.baseUrl + 'Privacypolicy'}>
                                Privacy policy
                            </a>
                        </li>
                    </ul>
                    <div className="update-log-menu">
                        <a href={this.baseUrl + 'setting/updateLog'}>
                            <p className="ver">ver. 0.2.13</p>
                            <br />
                            <p className="date">last updated on Oct. 8, 2018</p>
                        </a>
                    </div>
                </div>
                {this.state.isCanvas ? (
                    <div className="mask new-canvas-popup saveAsWrap">
                        <form
                            method="post"
                            id="CreateGroupFrm"
                            noValidate="novalidate"
                            action={this.baseUrl + '/group/makeCanvas'}
                        >
                            <div className="table absolute">
                                <div className="middle">
                                    <div className="new-canvas-popup__box">
                                        <div className="wrapB">
                                            <h2 className="wrap">
                                                Create a New Canvas
                                            </h2>
                                            <input
                                                type="hidden"
                                                id="csrf"
                                                name="ci_csrf_token"
                                                value=""
                                            />
                                            <select name="groupId">
                                                {this.props.groupList.map(
                                                    (v, k) => {
                                                        return (
                                                            <option
                                                                key={k}
                                                                value={
                                                                    v.groupId
                                                                }
                                                            >
                                                                {v.name}
                                                            </option>
                                                        );
                                                    },
                                                )}
                                            </select>
                                            <input
                                                type="text"
                                                name="name"
                                                className="input"
                                                placeholder="Canvas Title"
                                                required=""
                                                aria-required="true"
                                            />
                                            <div id="errorPlacement"></div>
                                            <input
                                                type="submit"
                                                value="Create"
                                                className="submitButton btn-back-round-black btn saveStay"
                                            />
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    this.setState({
                                                        isCanvas: false,
                                                    })
                                                }
                                                className="submitButton saveMove"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                ) : (
                    ''
                )}
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/RightMenu.js